import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// 사이트 공통 시각 효과 (브라우저에서만 동작, 사전 렌더링 HTML 에는 영향 없음)
// 1) 스크롤 리빌: [data-reveal] 요소가 화면에 들어오면 .is-visible 을 붙여 CSS 전환으로 나타나게 함
//    [data-reveal-stagger] 는 자식 요소들을 순서대로 지연시켜 등장
// 2) 커서 글로우: .glow-card 위에서 마우스 위치를 --gx/--gy 로 전달해 테두리·배경이 따라 빛남
export default function Effects() {
  const { pathname } = useLocation();

  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const els = Array.from(document.querySelectorAll<HTMLElement>("[data-reveal]:not(.is-visible)"));
    if (reduce || !("IntersectionObserver" in window)) {
      els.forEach((el) => el.classList.add("is-visible"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        for (const en of entries) {
          if (!en.isIntersecting) continue;
          en.target.classList.add("is-visible");
          io.unobserve(en.target);
        }
      },
      { threshold: 0.1, rootMargin: "0px 0px -6% 0px" }
    );
    els.forEach((el) => {
      if (el.hasAttribute("data-reveal-stagger")) {
        Array.from(el.children).forEach((c, i) =>
          (c as HTMLElement).style.setProperty("--reveal-delay", `${Math.min(i, 9) * 80}ms`)
        );
      }
      io.observe(el);
    });
    return () => io.disconnect();
  }, [pathname]);

  useEffect(() => {
    const onMove = (e: PointerEvent) => {
      const card = (e.target as Element | null)?.closest?.(".glow-card") as HTMLElement | null;
      if (!card) return;
      const r = card.getBoundingClientRect();
      card.style.setProperty("--gx", `${e.clientX - r.left}px`);
      card.style.setProperty("--gy", `${e.clientY - r.top}px`);
    };
    document.addEventListener("pointermove", onMove, { passive: true });
    return () => document.removeEventListener("pointermove", onMove);
  }, []);

  return null;
}
